import axios from "axios";
import { globalErrorHandler } from "./globalErrorHandler";
import store from "@/store";

const apiURL = process.env.VUE_APP_API_URL;

function fetchData(endpoint, requestType, requestBody, responseType) {
  let config = "";
  config = {
    headers: {
      "Content-Type": "application/json",
      charset: "utf-8",
      "accept-language": "hu",
    },
    responseType: responseType,
  };
  let formConfig = "";
  formConfig = {
    headers: {
      "Content-Type": `multipart/form-data`,
      charset: "utf-8",
      "accept-language": "hu",
    },
  };
  if (store.getters["users/loggedInUser"]) {
    config.headers["x-api-key"] = store.getters["users/apiKey"];
    formConfig.headers["x-api-key"] = store.getters["users/apiKey"];
  }

  return new Promise((resolve, reject) => {
    if (requestType.toUpperCase() === "POST") {
      return axios
        .post(endpoint, requestBody, config)
        .then((res) => resolve(res.data))
        .catch((err) => {
          if (err.response) {
            globalErrorHandler(err.response);
            return reject(err.response);
          }
          globalErrorHandler(err);
          return reject(err);
        });
    } else if (requestType.toUpperCase() === "POSTFORM") {
      return axios
        .put(endpoint, requestBody, formConfig)
        .then((res) => resolve(res.data))
        .catch((err) => {
          if (err.response) {
            globalErrorHandler(err.response);
            return reject(err.response);
          }
          globalErrorHandler(err);
          return reject(err);
        });
    } else if (requestType.toUpperCase() === "GET") {
      if (requestBody) {
        return axios
          .get(endpoint, { headers: config.headers, params: requestBody, responseType: responseType })
          .then((res) => resolve(res.data))
          .catch((err) => {
            if (err.response) {
              globalErrorHandler(err.response);
              return reject(err.response);
            }
            globalErrorHandler(err);
            return reject(err);
          });
      }
      return axios
        .get(endpoint, config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          if (err.response) {
            globalErrorHandler(err.response.data);
            return reject(err.response.data);
          }
          globalErrorHandler(err);
          return reject(err);
        });
    } else if (requestType.toUpperCase() === "PATCH") {
      return axios
        .patch(endpoint, requestBody, config)
        .then((res) => resolve(res.data))
        .catch((err) => {
          if (err.response) {
            globalErrorHandler(err.response);
            return reject(err.response);
          }
          globalErrorHandler(err);
          return reject(err);
        });
    } else if (requestType.toUpperCase() === "DELETE") {
      if (requestBody) {
        return axios
          .delete(endpoint, { headers: config.headers, data: requestBody })
          .then((res) => resolve(res.data))
          .catch((err) => {
            if (err.response) {
              globalErrorHandler(err.response);
              return reject(err.response);
            }
            globalErrorHandler(err);
            return reject(err);
          });
      }
      return axios
        .delete(endpoint, config)
        .then((res) => resolve(res.data))
        .catch((err) => {
          if (err.response) {
            globalErrorHandler(err.response);
            return reject(err.response);
          }
          globalErrorHandler(err);
          return reject(err);
        });
    } else if (requestType.toUpperCase() === "PUT") {
      return axios
        .put(endpoint, requestBody, config)
        .then((res) => resolve(res.data))
        .catch((err) => {
          if (err.response) {
            globalErrorHandler(err.response);
            return reject(err.response);
          }
          globalErrorHandler(err);
          return reject(err);
        });
    }
    throw new Error("Unknown HTTP method");
  });
}

export { fetchData, apiURL };
